(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fh-benefit-bar')) {
  customElements.define('fh-benefit-bar', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.fh-benefit-bar__item')];
      this.index = 0;
      this.media = matchMedia('(min-width:1100px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.refresh = () => {
        clearInterval(this.timer);
        this.items.forEach((item,i) => item.classList.toggle('is-selected', i === this.index));
        if (this.media.matches || this.motion.matches || document.hidden || !this.hasAttribute('data-autoplay') || this.items.length < 2 || this.selectedInEditor) return;
        this.timer = setInterval(() => {
          this.index = (this.index + 1) % this.items.length;
          this.items.forEach((item,i) => item.classList.toggle('is-selected', i === this.index));
        }, Number(this.dataset.speed) || 4500);
      };
      this.media.addEventListener('change',this.refresh,options);
      this.motion.addEventListener('change',this.refresh,options);
      document.addEventListener('visibilitychange',this.refresh,options);
      this.addEventListener('shopify:block:select',event => {this.selectedInEditor=true;const index=this.items.indexOf(event.target);if(index>=0)this.index=index;this.refresh();},options);
      this.addEventListener('shopify:block:deselect',() => {this.selectedInEditor=false;this.refresh();},options);
      this.refresh();
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-brand-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-brand-wordmark')) {
    customElements.define('fh-brand-wordmark', class extends HTMLElement {
      connectedCallback() {
        this.lastWidth = null;
        this.observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width !== this.lastWidth) {
            this.lastWidth = entry.contentRect.width;
            this.scheduleFit();
          }
        });
        this.observer.observe(this);
        this.scheduleFit();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleFit();
        });
      }

      disconnectedCallback() {
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }

      scheduleFit() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      }

      fit() {
        const availableWidth = this.getBoundingClientRect().width;
        if (!availableWidth) return;

        // Keep the existing type scale whenever the longest complete word fits.
        this.style.fontSize = 'var(--fh-wordmark-size)';
        const desiredSize = parseFloat(getComputedStyle(this).fontSize);
        const widestWord = Math.max(...Array.from(this.children, word => word.getBoundingClientRect().width));
        if (widestWord > availableWidth - 1) {
          this.style.fontSize = `${desiredSize * (availableWidth - 1) / widestWord}px`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const updateCount = (track) => {
      if (!track) return;
      const currentEl = track.closest('.fh-collection-intro__rail-inner')?.querySelector('[data-fh-rail-current]');
      const cards = track.querySelectorAll('.fh-collection-intro__card');
      if (!currentEl || !cards.length) return;
      const cardWidth = cards[0].getBoundingClientRect().width || 1;
      const index = Math.min(cards.length, Math.max(1, Math.round(track.scrollLeft / (cardWidth + 12)) + 1));
      currentEl.textContent = String(index).padStart(2, '0');
    };

    const bind = (root) => {
      (root || document).querySelectorAll('.fh-collection-intro__track').forEach((track) => {
        if (track.dataset.fhRailBound === 'true') return;
        track.dataset.fhRailBound = 'true';
        track.addEventListener('scroll', () => updateCount(track), { passive: true });
        updateCount(track);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bind(document));
    } else {
      bind(document);
    }
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.__fhHeroVideoBound) {
    window.__fhHeroVideoBound = true;

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const isVisible = (video) => {
      if (!video.isConnected) return false;
      const style = window.getComputedStyle(video);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return video.getClientRects().length > 0;
    };

    const armVideo = (video) => {
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
      video.setAttribute('preload', 'auto');
    };

    const tryPlay = (video) => {
      if (prefersReducedMotion() || !isVisible(video)) {
        video.pause();
        return;
      }

      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(() => {});
      }
    };

    const syncHeroVideos = (root) => {
      (root || document).querySelectorAll('.fh-hero video').forEach((video) => {
        armVideo(video);
        tryPlay(video);

        if (video.dataset.fhHeroArmed === 'true') return;
        video.dataset.fhHeroArmed = 'true';
        video.addEventListener('canplay', () => tryPlay(video));
        video.addEventListener('loadeddata', () => tryPlay(video));
        video.addEventListener('pause', () => {
          if (!prefersReducedMotion() && isVisible(video) && video.paused) tryPlay(video);
        });
      });
    };

    const bind = () => syncHeroVideos();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind, { once: true });
    } else {
      bind();
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) syncHeroVideos();
    });
    window.addEventListener('pageshow', () => syncHeroVideos());
    window.addEventListener('focus', () => syncHeroVideos());
    window.addEventListener('resize', () => syncHeroVideos());
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector && event.target.querySelector('.fh-hero')) {
        syncHeroVideos(event.target);
      }
    });
    ['touchstart', 'pointerdown'].forEach((eventName) => {
      document.addEventListener(eventName, () => syncHeroVideos(), { passive: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-journal-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-journal-article')) {
    customElements.define('fh-journal-article', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const body = this.querySelector('.fh-ja__body');
        const progress = this.querySelector('[data-reading-progress]');
        const chapters = [...this.querySelectorAll('[data-chapter]')];
        const links = [...this.querySelectorAll('[data-chapter-link]')];
        if (!body) return;
        const update = () => {
          this.frame = 0;
          const rect = body.getBoundingClientRect();
          const distance = Math.max(1, rect.height - innerHeight * .65);
          const amount = Math.min(1, Math.max(0, (innerHeight * .15 - rect.top) / distance));
          if (progress) progress.style.transform = `scaleX(${amount})`;
          let active = chapters[0]?.id;
          chapters.forEach(chapter => { if (chapter.getBoundingClientRect().top <= innerHeight * .3) active = chapter.id; });
          links.forEach(link => {
            if (link.dataset.chapterLink === active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        };
        const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', queue, { passive: true, signal });
        window.addEventListener('resize', queue, { passive: true, signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(queue);
        this.resizeObserver.observe(body);
        this.querySelectorAll('img').forEach(image => image.addEventListener('load', queue, { signal }));
        this.querySelectorAll('.fh-ja__mobile-toc a').forEach(link => link.addEventListener('click', () => {
          this.querySelector('.fh-ja__mobile-toc').open = false;
        }, { signal }));
        const share = this.querySelector('[data-share]');
        if (share) {
          share.hidden = false;
          share.addEventListener('click', async () => {
            const feedback = this.querySelector('[data-share-feedback]');
            const fallback = this.querySelector('[data-share-fallback]');
            const url = new URL(this.dataset.articleUrl, location.origin).href;
            try {
              if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
              await navigator.clipboard.writeText(url);
              if (!this.isConnected) return;
              feedback.textContent = this.dataset.copySuccess;
              fallback.hidden = true;
            } catch {
              if (!this.isConnected) return;
              fallback.hidden = false;
              const input = fallback.querySelector('input');
              input.value = url;
              input.focus();
              input.select();
              feedback.textContent = this.dataset.copyFallback;
            }
          }, { signal });
        }
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-journal-blog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-journal-blog')) {
    customElements.define('fh-journal-blog', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.entries = Array.from(this.querySelectorAll('[data-article-entry]'));
        this.filters = this.querySelector('[data-filters]');
        this.searchInput = this.querySelector('[data-search]');
        this.resultLabel = this.querySelector('[data-results]');
        this.feature = this.querySelector('[data-featured]');
        this.emptyState = this.querySelector('[data-empty]');
        if (!this.filters || !this.searchInput || !this.resultLabel) return;
        this.filters.querySelectorAll('[data-generated-filter]').forEach(button => button.remove());
        const topics = new Map();
        this.entries.forEach(entry => {
          const topic = entry.dataset.topic;
          if (topic) topics.set(topic, (topics.get(topic) || 0) + 1);
          entry.journalSearchText = this.normalize(entry.dataset.searchText);
        });
        this.filters.querySelector('[data-filter-count]').textContent = String(this.entries.length).padStart(2, '0');
        topics.forEach((count, topic) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.filter = topic;
          button.dataset.generatedFilter = '';
          button.setAttribute('aria-pressed', 'false');
          const label = document.createElement('span');
          label.textContent = topic;
          const counter = document.createElement('small');
          counter.textContent = String(count).padStart(2, '0');
          button.append(label, counter);
          this.filters.append(button);
        });
        this.topics = topics;
        this.filters.addEventListener('click', event => {
          const button = event.target.closest('[data-filter]');
          if (!button || !this.filters.contains(button)) return;
          this.activeTopic = button.dataset.filter;
          this.update(true);
        }, options);
        this.searchInput.addEventListener('input', () => this.update(true), options);
        this.querySelector('[data-search-form]').addEventListener('submit', event => {
          event.preventDefault();
          this.update(true);
        }, options);
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.activeTopic = '';
          this.searchInput.value = '';
          this.update(true);
          this.searchInput.focus();
        }, options);
        window.addEventListener('popstate', () => this.readLocation(), options);
        this.querySelector('[data-toolbar]').hidden = false;
        const scopeNotice = this.querySelector('[data-filter-scope]');
        if (scopeNotice) scopeNotice.hidden = false;
        this.readLocation();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      normalize(value) {
        return String(value || '').normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().trim();
      }

      readLocation() {
        const parameters = new URL(window.location.href).searchParams;
        const topic = parameters.get('thema') || '';
        this.activeTopic = this.topics.has(topic) ? topic : '';
        this.searchInput.value = parameters.get('suche') || '';
        this.update(false);
      }

      update(writeLocation) {
        const query = this.normalize(this.searchInput.value);
        const terms = query.split(/\s+/).filter(Boolean);
        const filtering = Boolean(this.activeTopic || query);
        let count = 0;
        this.entries.forEach(entry => {
          const matchesTopic = !this.activeTopic || entry.dataset.topic === this.activeTopic;
          const matchesSearch = terms.every(term => entry.journalSearchText.includes(term));
          const featuredAtTop = !filtering && this.feature && entry.hasAttribute('data-is-featured');
          entry.hidden = !(matchesTopic && matchesSearch) || Boolean(featuredAtTop);
          if (!entry.hidden) count += 1;
        });
        if (this.feature) this.feature.hidden = filtering;
        this.filters.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.activeTopic)));
        this.emptyState.hidden = count > 0 || !filtering;
        let label = filtering ? this.resultLabel.dataset.filtered : this.feature ? this.resultLabel.dataset.more : this.resultLabel.dataset.default;
        if (this.resultLabel.dataset.paginated === 'true') label = this.resultLabel.dataset.page;
        this.resultLabel.textContent = label.replaceAll('[count]', String(count));
        if (writeLocation) {
          const url = new URL(window.location.href);
          if (this.activeTopic) url.searchParams.set('thema', this.activeTopic);
          else url.searchParams.delete('thema');
          const search = this.searchInput.value.trim();
          if (search) url.searchParams.set('suche', search);
          else url.searchParams.delete('suche');
          window.history.replaceState(window.history.state, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-lookbook-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-lookbook-product')) {
    customElements.define('fh-lookbook-product', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.rerender = this.querySelector('product-rerender');
        this.addEventListener('change', this.onOptionChange.bind(this), { capture: true, signal: this.controller.signal });
        this.addEventListener('submit', this.onSubmit.bind(this), { capture: true, signal: this.controller.signal });
        this.addEventListener('toggle', this.onDisclosureToggle.bind(this), { capture: true, signal: this.controller.signal });
        this.observer = new MutationObserver(() => {
          const next = this.querySelector('product-rerender');
          if (next !== this.rerender) {
            this.rerender = next;
            this.pending = false;
            this.removeAttribute('aria-busy');
            this.removeAttribute('data-selection-error');
            clearTimeout(this.selectionTimeout);
          }
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
        clearTimeout(this.selectionTimeout);
      }

      onOptionChange(event) {
        if (!event.target.matches('input[data-option-position]')) return;
        const form = document.forms[this.dataset.formId];
        if (!form) return;
        this.pending = true;
        this.setAttribute('aria-busy', 'true');
        const choices = Array.from(form.elements).filter(input => input.matches('input[data-option-position]:checked'));
        choices.sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
        const currentUrl = new URL(window.location.href);
        const isProductPreview = /(?:^|\/)products_preview\/?$/.test(currentUrl.pathname);
        const fallbackUrl = isProductPreview ? currentUrl : new URL(this.dataset.productUrl, window.location.origin);
        if (isProductPreview) {
          event.stopImmediatePropagation();
          fallbackUrl.searchParams.delete('variant');
        }
        fallbackUrl.searchParams.set('option_values', choices.map(input => input.value).join(','));
        const retry = this.querySelector('[data-selection-retry]');
        if (retry) retry.href = fallbackUrl.href;
        for (const input of form.elements) {
          if (input.type === 'submit' || input.matches('input[data-option-position]')) input.disabled = true;
        }
        const feedback = this.querySelector('[data-selection-feedback]');
        if (feedback) {
          feedback.hidden = false;
          feedback.textContent = this.dataset.loadingMessage;
        }
        clearTimeout(this.selectionTimeout);
        if (isProductPreview) {
          window.location.assign(fallbackUrl.href);
          return;
        }
        this.selectionTimeout = setTimeout(() => {
          if (!this.pending) return;
          this.removeAttribute('aria-busy');
          this.setAttribute('data-selection-error', '');
          if (feedback?.isConnected) feedback.textContent = this.dataset.errorMessage;
          if (retry?.isConnected) retry.hidden = false;
        }, 12000);
      }

      onSubmit(event) {
        const form = document.forms[this.dataset.formId];
        if (event.target !== form) return;
        if (this.pending || !form.elements.namedItem('id')?.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const feedback = this.querySelector('[data-selection-feedback]');
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = this.pending ? this.dataset.loadingMessage : this.dataset.unavailableMessage;
          }
        }
      }

      onDisclosureToggle(event) {
        const detail = event.target;
        if (!detail.matches('.fh-lbp__faq-item') || !detail.open) return;
        this.querySelectorAll('.fh-lbp__faq-item').forEach(other => {
          if (other !== detail) other.open = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-shop-your-style"] && !Shopify.designMode) return;
  try {
    
  if (!window.__fhShopYourStyleBound) {
    window.__fhShopYourStyleBound = true;

    const addLookToCart = async (button) => {
      if (button.getAttribute('aria-busy') === 'true' || button.disabled) return;

      let items = [];
      try {
        items = JSON.parse(button.getAttribute('data-items') || '[]');
      } catch (error) {
        items = [];
      }

      if (!items.length) return;

      button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      const routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

      try {
        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: sectionsToBundle.join(',')
          })
        });

        const responseJson = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        button.removeAttribute('aria-busy');

        if (!response.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: responseJson.description || responseJson.message }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        const cartContent = await (await fetch(`${routesRoot}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart: cartContent
          }
        }));
      } catch (error) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        button.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const bundle = event.target.closest('[data-fh-bundle]');
      if (bundle) {
        event.preventDefault();
        addLookToCart(bundle);
        return;
      }

      const pin = event.target.closest('[data-fh-pin]');
      const root = event.target.closest('[data-fh-shop-your-style]');
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (finePointer) return;

      if (pin) {
        if (pin.getAttribute('aria-expanded') !== 'true') {
          event.preventDefault();
          (root || document).querySelectorAll('[data-fh-pin][aria-expanded="true"]').forEach((openPin) => {
            openPin.setAttribute('aria-expanded', 'false');
          });
          pin.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      document.querySelectorAll('[data-fh-pin][aria-expanded="true"]').forEach((openPin) => {
        openPin.setAttribute('aria-expanded', 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
